import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

const DAY_PRESETS = [
    { days: 182, label: '6 mnd' },
    { days: 365, label: '1 år' },
    { days: 730, label: '2 år' },
    { days: 1095, label: '3 år' },
];

@observer
class NewNotificationQuick extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            searching: false,
            results: [],
            product: null,
            days: 365,
            saving: false,
            message: null,
            error: null,
        };
        this.searchTimer = null;
    }

    searchInput = (e) => {
        const search = e.target.value;
        this.setState({ search });
        clearTimeout(this.searchTimer);
        if (search.length >= 3) {
            this.searchTimer = setTimeout(() => this.doSearch(search), 300);
        } else {
            this.setState({ results: [] });
        }
    }

    doSearch = async (search) => {
        const { productStore } = this.props.stores;
        this.setState({ searching: true });
        const results = await productStore.load({ query: { search }, skipUpdate: true, limit: 10 });
        this.setState({ results: results || [], searching: false });
    }

    onClickProduct = (product) => {
        this.setState({ product, results: [], search: '' });
    }

    onClickRemoveProduct = () => {
        this.setState({ product: null });
    }

    onDaysInput = (e) => {
        this.setState({ days: e.target.value });
    }

    onClickPreset = (days) => {
        this.setState({ days });
    }

    onClickSave = async () => {
        const { animal, callback = () => {}, drawerLevel = 1 } = this.props;
        const { appState, calendarEventStore } = this.props.stores;
        const { product, days } = this.state;
        this.setState({ saving: true, error: null });
        const response = await calendarEventStore.createQuickNotification({
            animalId: animal.id,
            productId: product ? product.id : undefined,
            days: parseInt(days, 10) || 365,
        });
        if (response && response.status === 200) {
            this.setState({ saving: false, message: true });
            callback(response.data);
            setTimeout(() => {
                appState.toggleDrawer(false, drawerLevel);
            }, 800);
        } else {
            this.setState({ saving: false, error: true });
        }
    }

    render() {
        const { animal = {} } = this.props;
        const { search, searching, results, product, days, saving, message, error } = this.state;

        const daysInt = parseInt(days, 10) || 0;
        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() + daysInt);
        const targetDateString = daysInt > 0
            ? targetDate.toLocaleDateString('nb-NO', { year: 'numeric', month: 'long', day: '2-digit' })
            : '';

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 600px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        <i class='fa-duotone fa-bell me-2' />
                        <Text id='dyrejournal.notification-quick-title'>New recall</Text>
                        {animal.name && <>: {animal.name}</>}
                    </div>

                    <div class='px-3 pt-3'>
                        <label class='form-label mb-1'>
                            <Text id='dyrejournal.notification-quick-product-label'>Product / recall type (optional)</Text>
                        </label>
                        {product ? (
                            <div class='alert alert-info d-flex flex-row justify-content-between align-items-center py-2 px-3 mb-2'>
                                <span>
                                    <i class='fa-duotone fa-syringe me-2' />
                                    {product.name}
                                    {!!product.productNumber && <small class='text-body-secondary ms-2'>#{product.productNumber}</small>}
                                </span>
                                <button type='button' class='btn btn-sm btn-link text-danger p-0' onClick={this.onClickRemoveProduct}>
                                    <i class='fa-solid fa-xmark' />
                                </button>
                            </div>
                        ) : (
                            <>
                                <input
                                    type='text'
                                    class='form-control'
                                    value={search}
                                    onInput={this.searchInput}
                                    placeholder='Søk etter produkt...'
                                />
                                {searching && <small class='text-body-secondary'><Text id='dyrejournal.notification-quick-searching'>Searching...</Text></small>}
                                {results.length > 0 && (
                                    <div class='list-group shadow mt-1' style='max-height: 40vh; overflow-y: auto;'>
                                        {results.map(p => (
                                            <button
                                                type='button'
                                                key={p.id}
                                                class='list-group-item list-group-item-action'
                                                onClick={() => this.onClickProduct(p)}
                                            >
                                                <strong>{p.name}</strong>
                                                {!!p.productNumber && <small class='text-body-secondary ms-2'>#{p.productNumber}</small>}
                                                {p.reminderDays > 0 && (
                                                    <small class='text-body-secondary ms-2'>
                                                        <i class='fa-duotone fa-bell me-1' />{p.reminderDays}d
                                                    </small>
                                                )}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </>
                        )}
                    </div>

                    <div class='px-3 pt-3'>
                        <label class='form-label mb-1'>
                            <Text id='dyrejournal.notification-quick-days-label'>Days from today</Text>
                        </label>
                        <div class='d-flex flex-row align-items-center'>
                            <input
                                type='number'
                                class='form-control'
                                style='max-width: 120px;'
                                min='1'
                                max='3650'
                                value={days}
                                onInput={this.onDaysInput}
                            />
                            <div class='ms-2'>
                                {DAY_PRESETS.map(preset => (
                                    <button
                                        type='button'
                                        key={preset.days}
                                        class={`btn btn-sm rounded-pill me-1 ${daysInt === preset.days ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                        onClick={() => this.onClickPreset(preset.days)}
                                    >
                                        {preset.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                        {targetDateString && (
                            <div class='mt-2'>
                                <i class='fa-duotone fa-calendar-day me-2 text-body-secondary' />
                                <Text id='dyrejournal.notification-quick-date'>Recall date</Text>: <strong>{targetDateString}</strong>
                            </div>
                        )}
                    </div>

                    <div class='px-3 pt-4'>
                        <button
                            type='button'
                            class='btn btn-primary rounded-pill'
                            disabled={saving || daysInt < 1}
                            onClick={this.onClickSave}
                        >
                            {saving ? <i class='fa-solid fa-spinner fa-spin me-2' /> : <i class='fa-duotone fa-floppy-disk me-2' />}
                            <Text id='dyrejournal.notification-quick-save'>Save recall</Text>
                        </button>
                        {message && (
                            <div class='alert alert-success mt-3 py-2'>
                                <i class='fa-solid fa-check me-2' />
                                <Text id='dyrejournal.notification-quick-saved'>Recall created!</Text>
                            </div>
                        )}
                        {error && (
                            <div class='alert alert-danger mt-3 py-2'>
                                <i class='fa-solid fa-triangle-exclamation me-2' />
                                <Text id='dyrejournal.notification-quick-error'>Could not create the recall. Please try again.</Text>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default NewNotificationQuick;
